var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewDocs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#16304F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4038 13.8088C21.7422 12.0974 20.5936 10.6175 19.1001 9.5518C17.6065 8.48612 15.8335 7.88145 14 7.8125C12.1665 7.88145 10.3935 8.48612 8.89993 9.5518C7.40639 10.6175 6.25785 12.0974 5.59625 13.8088C5.55157 13.9323 5.55157 14.0677 5.59625 14.1912C6.25785 15.9026 7.40639 17.3825 8.89993 18.4482C10.3935 19.5139 12.1665 20.1186 14 20.1875C15.8335 20.1186 17.6065 19.5139 19.1001 18.4482C20.5936 17.3825 21.7422 15.9026 22.4038 14.1912C22.4484 14.0677 22.4484 13.9323 22.4038 13.8088ZM14 19.0625C11.0188 19.0625 7.86875 16.8519 6.72688 14C7.86875 11.1481 11.0188 8.9375 14 8.9375C16.9813 8.9375 20.1313 11.1481 21.2731 14C20.1313 16.8519 16.9813 19.0625 14 19.0625Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10.625C13.3325 10.625 12.68 10.8229 12.125 11.1938C11.5699 11.5646 11.1374 12.0917 10.8819 12.7084C10.6265 13.3251 10.5596 14.0037 10.6899 14.6584C10.8201 15.3131 11.1415 15.9145 11.6135 16.3865C12.0855 16.8585 12.6869 17.1799 13.3416 17.3102C13.9963 17.4404 14.6749 17.3735 15.2916 17.1181C15.9083 16.8626 16.4354 16.4301 16.8062 15.875C17.1771 15.32 17.375 14.6675 17.375 14C17.375 13.1049 17.0194 12.2464 16.3865 11.6135C15.7536 10.9806 14.8951 10.625 14 10.625ZM14 16.25C13.555 16.25 13.12 16.118 12.75 15.8708C12.38 15.6236 12.0916 15.2722 11.9213 14.861C11.751 14.4499 11.7064 13.9975 11.7932 13.561C11.8801 13.1246 12.0943 12.7237 12.409 12.409C12.7237 12.0943 13.1246 11.88 13.561 11.7932C13.9975 11.7064 14.4499 11.751 14.861 11.9213C15.2722 12.0916 15.6236 12.38 15.8708 12.75C16.118 13.12 16.25 13.555 16.25 14C16.25 14.5967 16.0129 15.169 15.591 15.591C15.169 16.0129 14.5967 16.25 14 16.25Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewDocs);
export default __webpack_public_path__ + "static/media/view-docs.190c8ec623b9e355322f3e2af8f6014c.svg";
export { ForwardRef as ReactComponent };